import { useUI } from "providers/UIProvider"
import useBookingFee from "hooks/useBookingFee"

import { Box, Center } from "@chakra-ui/react"

import Input from "components/UI/atoms/Input"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useLocation } from "react-router-dom"
import { BOOKING_FEE_TABS } from "types/shared"
import { useAppContext } from "providers/AppProvider/AppProvider"

const BookingFeeForm = () => {
  const { T } = useUI()
  const { form: { values, errors, touched, handleChange, handleSubmit } } = useBookingFee()
  const { commissionTabType, changeLaundryCommissionLoading } = useSettings()
  const { selectedBranches } = useAppContext()
  const isPercent = commissionTabType === BOOKING_FEE_TABS.PERCENT
  const { pathname } = useLocation()

  return (
    <>
      <Box mt="30px">
        <form>
          <Box>
            <Input
              id="booking-fee-amount"
              label={isPercent ? `${T("booking_fee.form.amount_percent_label")}` : `${T("booking_fee.form.amount_fixed_label")}`}
              name="amount"
              placeholder={values.placeholderAmount}
              value={values.amount}
              onChange={handleChange}
              type="number"
              error={Boolean(errors.amount && touched.amount)}
              errorMessage={errors.amount}
            />
          </Box>
          <Center as="footer" mt="85px">
            <Button
              text={T("actions.confirm")}
              onClick={handleSubmit}
              variant="success"
              styles={{
                width: "280px",
                height: "80px",
                fontSize: "xxl"
              }}
              leftIcon={
                <Icon
                  name="confirm"
                  iconStyles={{ width: "30px", height: "30px" }}
                />
              }
              _hover={{ backgroundColor: "#08BA36" }}
              isLoading={changeLaundryCommissionLoading}
              isDisabled={changeLaundryCommissionLoading || (selectedBranches.length === 0 && pathname === "/settings/booking_fee")}
            />
          </Center>
        </form>
      </Box>
    </>
  )
}

export default BookingFeeForm